import React from 'react';
import { Box } from '../Rebass';
import Button from '../Button';

interface ShareProps {
  icon: string;
  size?: 'default' | 'small' | 'large';
}

const Share = ({ icon, size = 'default' }: ShareProps) => (
  <Box mr={[1]}>
    <Button variant="icon" size={size} icon={icon} colorScheme="bgLight" />
  </Box>
);

export default Share;
